export const PORTAL_URL = process.env.REACT_APP_PORTAL_URL;
export const IS_PORTAL_HOST = !!PORTAL_URL && window.location.hostname === new URL(PORTAL_URL).hostname;
const BASE = IS_PORTAL_HOST ? "" : "/portail";
export const pp = (p = "") => `${BASE}${p}` || "/";
export const portalPublic = (p = "") => `${PORTAL_URL}${p}`;
